import { Stepper, Step, StepLabel, StepConnector, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";

/* ---------------- STEPS ---------------- */

const steps = ["Allotment", "Applicant", "Bank", "Confirm"];

/* ---------------- COLORS ---------------- */

const COLORS = {
  completed: "#16A34A",
  active: "#1F3A5F",
  inactive: "#E5E7EB",
  textActive: "#0F172A",
  textInactive: "#64748B",
};

/* ---------------- CUSTOM CONNECTOR ---------------- */

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  alternativeLabel: {
    top: 22,
  },

  "& .MuiStepConnector-line": {
    height: 4,
    border: 0,
    borderRadius: 4,
    backgroundColor: COLORS.inactive,
    width: "60%",
    margin: "0 auto",
  },

  "&.Mui-completed .MuiStepConnector-line": {
    backgroundColor: COLORS.completed,
  },

  "&.Mui-active .MuiStepConnector-line": {
    backgroundColor: COLORS.completed,
  },

  /* Mobile adjustments */
  [theme.breakpoints.down("sm")]: {
    "& .MuiStepConnector-line": {
      width: "50%",
    },
  },
}));

/* ---------------- CUSTOM STEP ICON ---------------- */

const CustomStepIcon = ({ active, completed, icon }) => {
  return (
    <Box
      sx={{
        width: { xs: 40, sm: 36 },
        height: { xs: 40, sm: 36 },
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: { xs: 15, sm: 14 },
        fontWeight: 600,

        backgroundColor: completed
          ? COLORS.completed
          : active
          ? COLORS.active
          : COLORS.inactive,

        color: completed || active ? "#FFFFFF" : COLORS.textInactive,

        boxShadow: active
          ? "0px 4px 10px rgba(31, 58, 95, 0.35)"
          : "none",
      }}
    >
      {completed ? <CheckIcon sx={{ fontSize: 18 }} /> : icon}
    </Box>
  );
};

/* ---------------- MAIN COMPONENT ---------------- */

const EMandateStepper = ({ activeStep = 0 }) => {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<CustomConnector />}
      sx={{
        mt: { xs: 2, sm: 4 },
        px: { xs: 1, sm: 0 },
      }}
    >
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={CustomStepIcon}
            sx={{
              "& .MuiStepLabel-label": {
                fontSize: { xs: 12, sm: 13 },
                mt: 1,
                textAlign: "center",
                lineHeight: 1.3,
                color: COLORS.textInactive,
                fontWeight: 400,
                whiteSpace: "normal",
              },

              "& .MuiStepLabel-label.Mui-active": {
                color: COLORS.textActive,
                fontWeight: 600,
              },

              "& .MuiStepLabel-label.Mui-completed": {
                color: COLORS.textActive,
                fontWeight: 500,
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default EMandateStepper;
